import React,{useEffect,useState} from "react";
import CategorieSection from "./categorieSection";
import BlogSection from "./blogSection";
import {corefetch, ImageURL } from "../../../Util/axios_core_helper";

const BlogPage = () => {
  const [BreadcrumList, setBreadcrumList] = useState([]);
    
       const fetchBreadcrumImageData = async () => {
          try {
            const response = await corefetch(
              "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=BLOG"
            );
            if (response && response.length > 0) {
              console.log("fxftyxfyt:", response);
              setBreadcrumList(response);
            } else {
              setBreadcrumList([]);
              console.log("No Breadcrum found");
            }
          } catch (error) {
            console.error("Error fetching Breadcrum List:", error);
            setBreadcrumList([]);
          }
        };
    
        useEffect(() => {
            fetchBreadcrumImageData();
          }, []);
    
          const backgroundImageStyle = BreadcrumList[0]
          ? {
              backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {};
    return (
      <>
        <section className="wpo-page-title" style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-breadcumb-wrap">
                <h2>Latest News</h2>
                <ol className="wpo-breadcumb-wrap">
                  <li>
                    <a href="/home">Home</a>
                  </li>
                  <li>Blog</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="wpo-blog-pg-section  blog-pg-left-sidebar section-padding"
        style={{ marginTop: "20px" }}
      >
        <div class="container">
          <div class="row">
            <BlogSection />

            <CategorieSection />
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogPage;
